import { useMutation, useQueryClient } from "@tanstack/react-query";
import { researchService } from "../services/research.service";
import {
  ResearchChatMessage,
  ResearchChatData,
} from "../types/research.types";

export const useSendResearchMessage = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: researchService.sendMessage,
    mutationKey: ["sendResearchMessage"],
    onMutate: async (variables) => {
      await queryClient.cancelQueries({ queryKey: ["chat", variables.chat_id] });
      const previousChat = queryClient.getQueryData<ResearchChatData>(["chat", variables.chat_id]);

      if (previousChat) {
        const optimisticMessage: ResearchChatMessage = {
          question: variables.data,
          response: "",
          creation_date: new Date().toISOString(),
          related_questions: [],
        };
        const optimisticChat: ResearchChatData = {
          ...previousChat,
          prev_chat: [...previousChat.prev_chat, optimisticMessage],
        };
        queryClient.setQueryData<ResearchChatData>(["chat", variables.chat_id], optimisticChat);
      }
      return { previousChat };
    },
    onError: (_error, variables, context) => {
      if (context?.previousChat) {
        queryClient.setQueryData<ResearchChatData>(
          ["chat", variables.chat_id],
          context.previousChat
        );
      }
    },
    onSettled: (_data, _error, variables) => {
      queryClient.invalidateQueries({ queryKey: ["chat", variables.chat_id] });
      queryClient.invalidateQueries({ queryKey: ["chats"] });
    },
  });
};
